module.exports = __webpack_public_path__ + "19c14753f3ee6192ff5999ccc7249b86.svg";